import React from 'react';
import ScrollAnimation from '../components/ScrollAnimation';
import './About.css';

const About = () => {
  return (
    <div className="about">
      <section className="about-hero section">
        <div className="container">
          <ScrollAnimation delay={0}>
            <h1 className="page-title">About CableBiz</h1>
          </ScrollAnimation>
          <ScrollAnimation delay={200}>
            <p className="page-subtitle">
              Empowering cable TV operators and customers with innovative billing and management solutions
            </p>
          </ScrollAnimation>
        </div>
      </section>

      <section className="about-content section">
        <div className="container">
          <div className="about-grid">
            <ScrollAnimation delay={0}>
              <div className="about-text">
                <h2>Our Mission</h2>
                <p>
                  CableBiz is a comprehensive online billing software designed specifically for cable TV operators 
                  and their customers. We aim to simplify the entire cable TV management ecosystem, from subscription 
                  management to payment processing and customer service.
                </p>
                <p>
                  Our platform provides a complete solution that includes plan management, customer database, 
                  real-time reporting, and mobile applications for both operators and customers. We believe in 
                  making cable TV management effortless and efficient.
                </p>
              </div>
            </ScrollAnimation>
            <ScrollAnimation delay={300}>
              <div className="about-image">
                <div className="image-placeholder">
                  <div className="placeholder-icon">📺</div>
                  <p>CableBiz Platform</p>
                </div>
              </div>
            </ScrollAnimation>
          </div>
        </div>
      </section>

      <section className="values section bg-light">
        <div className="container">
          <ScrollAnimation delay={0}>
            <h2 className="section-title">Why Choose CableBiz?</h2>
          </ScrollAnimation>
          <div className="values-grid">
            <ScrollAnimation delay={100}>
              <div className="value-card">
                <div className="value-icon-wrapper">
                  <div className="value-icon-bg"></div>
                  <div className="value-icon">⚡</div>
                </div>
                <h3>Efficient</h3>
                <p>Streamline your operations with automated billing and management tools.</p>
              </div>
            </ScrollAnimation>
            <ScrollAnimation delay={200}>
              <div className="value-card">
                <div className="value-icon-wrapper">
                  <div className="value-icon-bg"></div>
                  <div className="value-icon">🔒</div>
                </div>
                <h3>Secure</h3>
                <p>Your data is protected with enterprise-grade security measures.</p>
              </div>
            </ScrollAnimation>
            <ScrollAnimation delay={300}>
              <div className="value-card">
                <div className="value-icon-wrapper">
                  <div className="value-icon-bg"></div>
                  <div className="value-icon">📱</div>
                </div>
                <h3>Mobile-First</h3>
                <p>Access your account and manage operations from anywhere, anytime.</p>
              </div>
            </ScrollAnimation>
            <ScrollAnimation delay={400}>
              <div className="value-card">
                <div className="value-icon-wrapper">
                  <div className="value-icon-bg"></div>
                  <div className="value-icon">📊</div>
                </div>
                <h3>Analytics</h3>
                <p>Make data-driven decisions with comprehensive reporting and analytics.</p>
              </div>
            </ScrollAnimation>
            <ScrollAnimation delay={500}>
              <div className="value-card">
                <div className="value-icon-wrapper">
                  <div className="value-icon-bg"></div>
                  <div className="value-icon">💬</div>
                </div>
                <h3>Support</h3>
                <p>Dedicated support team to help you whenever you need assistance.</p>
              </div>
            </ScrollAnimation>
            <ScrollAnimation delay={600}>
              <div className="value-card">
                <div className="value-icon-wrapper">
                  <div className="value-icon-bg"></div>
                  <div className="value-icon">🚀</div>
                </div>
                <h3>Innovative</h3>
                <p>Continuously evolving platform with latest features and updates.</p>
              </div>
            </ScrollAnimation>
          </div>
        </div>
      </section>

      <section className="company section">
        <div className="container">
          <ScrollAnimation delay={0}>
            <div className="company-info">
              <h2 className="section-title">About Neeladri Software Solutions</h2>
              <p className="company-description">
                CableBiz is a trademark owned and operated by <strong>Neeladri Software Solutions Pvt Ltd Private Limited</strong>, 
                a leading software development company based in Bhubaneswar, Odisha, India.
              </p>
              <p className="company-description">
                We specialize in developing innovative software solutions for various industries, with a particular 
                focus on billing and management systems. Our team of experienced developers and designers work 
                tirelessly to deliver products that exceed expectations.
              </p>
            </div>
          </ScrollAnimation>
        </div>
      </section>
    </div>
  );
};

export default About;

